import {
    doc,
    getDoc
  } from "firebase/firestore";
import { db } from "../firebase";

const getStepDetails = async (id, step) => {
    try {
        const stepRef = doc(db, step, id);
        const stepSnap = await getDoc(stepRef);
        
        if(stepSnap.exists()){
        return stepSnap.data();
        }
        else{
        return null;
        }
    } catch (error) {
        console.log(error)
    }
};

const stepController = {
    getStepDetails
}
  
export default stepController